import React from "react";
import {inject, observer} from "mobx-react";
import {Tooltip, withStyles} from "@material-ui/core";
import {
    AfericaoVital,
    AnamneseIcon,
    DadoAntropometrico,
    DocumentoIcon,
    EncaminhamentoIcon,
    EvahIaIcon,
    GuiaInternacaoIcon,
    MedicineIcon,
    orcamentoIcon,
    ProcedimentosIcon,
    SADTIcon,
    TGOIcon
} from "../../assets/img/svg";
import ImageSearchIcon from "@material-ui/icons/ImageSearch";
import ButtonOptions from "./ButtonOptions";
import LabelButton from "../../components/Button/LabelButton";
import {checkUserRole} from '../../utils/checkUserRole';

@inject("prontuarioStore", "unidadeStore")
@observer
class OpcoesProntuario extends React.Component {
    state = {
        openOptions: false,
        showTooltipIA: false
    }
    
    async componentDidMount() {
        const { prontuarioStore } = this.props;
        const { hasEvahIaDetalhado } = prontuarioStore;
        const profissionalSaudeLogado = JSON.parse(localStorage[`_immortal|profissional_saude_logado`] || null);

        const canCreateGuiaInternacao = await checkUserRole('ROLE_GUIA_INTERNACAO_CREATE');
        prontuarioStore.canCreateGuiaInternacao = canCreateGuiaInternacao;
        prontuarioStore.findAllButtonsProntuario();
        
        if(!hasEvahIaDetalhado && !profissionalSaudeLogado?.possuiPagamentoIndividualIAAtiva) {
            setTimeout(() => {
                this.setState({ showTooltipIA: true });
                setTimeout(() => {
                    this.setState({ showTooltipIA: false });
                }, 3000);
            }, 2000);
        }
    }

    clickOptions = (tipo) => {
        this.changeOptionsState(false);
        switch (tipo) {
            case 'receita':
                return this.props.handleOpenReceituario();
            case 'documento':
                return this.props.handleDocument();
            case 'sadt':
                return this.props.handleClickSADT();
            case 'guiaInternacao':
                return this.props.handleClickGuiaInternacao();
            case 'procedimento':
                return this.props.handleClickSolicitacaoProcedimento();
            case 'anamnese':
                return this.props.handleClickAnamnese();
            case 'avaliacaoAntropometrica':
                return this.props.handleClickAvaliacaoAntropometrica();
            case 'triagem':
                return this.props.handleClickTriagem();
            case 'encaminhamento':
                return this.props.handleClickEncaminhamento();
            case 'evahIa':
                this.setState({ showTooltipIA: false });
                return this.props.handleClickEvahIa();
            case 'orcamento':
                return this.props.handleClickOrcamento();
            case 'tgo':
                return this.props.handleClickGuiaTGO();
            case 'exames':
                return this.props.handleClickExames();
            default:
                return ;
        }
    }

    changeOptionsState = (value) => {
        this.setState({openOptions: value});
    }

    renderButtons = hiddenLabel => {
        const { classes, hiddenProcedimentosButton, sujeitoAtencaoId } = this.props;
        const hiddenLabelButton = hiddenLabel === "hiddenLabel";
        const { canCreateGuiaInternacao, hasEvahIaDetalhado } = this.props.prontuarioStore;
        const { prontuarioStore } = this.props;

        const button = prontuarioStore?.botoesProntuario && prontuarioStore?.botoesProntuario?.reduce((acc, { botao, visivel }) => {
            acc[botao] = visivel
            return acc
        }, {});
       
        return(
            <div className={classes.buttonsContent}>
                <LabelButton
                    id='prt-opc-btn-rec'
                    hiddenLabel = {hiddenLabelButton}
                    title={"Receita"}
                    icon={MedicineIcon}
                    onClick={() => this.clickOptions('receita')}
                    disabled={!sujeitoAtencaoId}
                    hidden={!button?.["RECEITA"]}
                />
                <LabelButton
                   id='prt-opc-btn-doc'
                   hiddenLabel = {hiddenLabelButton}
                   title={"Documento"}
                   icon={DocumentoIcon}
                   onClick={() => this.clickOptions('documento')}
                   disabled={!sujeitoAtencaoId}
                   hidden={!button?.["DOCUMENTO"]}
                />
                <LabelButton
                    id='prt-opc-btn-tgo'
                    hiddenLabel = {hiddenLabelButton}
                    title={"Guia GTO"}
                    icon={TGOIcon}
                    onClick={() => this.clickOptions('tgo')}
                    disabled={!sujeitoAtencaoId}
                    hidden={!button?.["GUIA_GTO"]}
                />
                <LabelButton
                    id='prt-opc-btn-sps'
                    hiddenLabel = {hiddenLabelButton}
                    title={"SP/SADT"}
                    icon={SADTIcon}
                    onClick={() => this.clickOptions('sadt')}
                    disabled={!sujeitoAtencaoId}
                    hidden={!button?.["SP_SADT"]}
                />
                {canCreateGuiaInternacao && (
                    <LabelButton
                        id='prt-opc-btn-gin'
                        hiddenLabel = {hiddenLabelButton}
                        title={"Guia de internção"}
                        icon={GuiaInternacaoIcon}
                        onClick={() => this.clickOptions('guiaInternacao')}
                        disabled={!sujeitoAtencaoId}
                        hidden={!button?.["GUIA_INTERNACAO"]}
                    />
                )}
                {!hiddenProcedimentosButton &&
                    <LabelButton
                        id='prt-opc-btn-prc'
                        hiddenLabel = {hiddenLabelButton}
                        title={"Procedimentos"}
                        icon={ProcedimentosIcon}
                        onClick={() => this.clickOptions('procedimento')}
                        disabled={!sujeitoAtencaoId}
                        hidden={!button?.["PROCEDIMENTOS"]}
                    />
                }
                <LabelButton
                    id='prt-opc-btn-ana'
                    hiddenLabel = {hiddenLabelButton}
                    title={"Anamnese"}
                    icon={AnamneseIcon}
                    onClick={() => this.clickOptions('anamnese')}
                    disabled={!sujeitoAtencaoId}
                    hidden={!button?.["ANAMNESE"]}
                />
                <LabelButton
                    id='prt-opc-btn-dan'
                    hiddenLabel = {hiddenLabelButton}
                    title={"Dados antropométricos"}
                    icon={DadoAntropometrico}
                    onClick={() => this.clickOptions('avaliacaoAntropometrica')}
                    disabled={!sujeitoAtencaoId}
                    hidden={!button?.["DADOS_ANTROPOMETRICOS"]}
                />
                <LabelButton
                    id='prt-opc-btn-orc'
                    hiddenLabel={hiddenLabelButton}
                    title={"Orçamento"}
                    icon={orcamentoIcon}
                    onClick={() => this.clickOptions('orcamento')}
                    disabled={!sujeitoAtencaoId}
                    hidden={!button?.["ORCAMENTOS"]}
                />
                <LabelButton
                    id='prt-opc-btn-afv'
                    hiddenLabel = {hiddenLabelButton}
                    title={"Aferições vitais"}
                    icon={AfericaoVital}
                    onClick={() => this.clickOptions('triagem')}
                    disabled={!sujeitoAtencaoId}
                    hidden={!button?.["AFERICOES_VITAIS"]}
                />
                <LabelButton
                    id='prt-opc-btn-enc'
                    hiddenLabel={hiddenLabelButton}
                    title={"Encaminhamento"}
                    icon={EncaminhamentoIcon}
                    onClick={() => this.clickOptions('encaminhamento')}
                    disabled={!sujeitoAtencaoId}
                    hidden={!button?.["ENCAMINHAMENTOS"]}
                />
                <LabelButton
                    id='prt-opc-btn-exm'
                    hiddenLabel={hiddenLabelButton}
                    title={"Exames"}
                    icon={<ImageSearchIcon style={{ color: '#fff', fontSize: 20 }} />}
                    onClick={() => this.clickOptions('exames')}
                    disabled={!sujeitoAtencaoId}
                    hidden={!button?.["EXAME"] || !this.props.unidadeStore?.configuracaoUnidade?.utilizaPacsweb}
                />
                {window.location.hash.includes('/atendimento/prontuario') && <Tooltip 
                    open={this.state.showTooltipIA} 
                    title="Ganhe tempo com IA no prontuário" 
                    placement="left"
                    disableHoverListener
                    disableFocusListener
                    disableTouchListener
                    classes={{ tooltip: classes.customTooltip }}
                >
                    <LabelButton
                        id='prt-opc-btn-eia'
                        hiddenLabel={hiddenLabelButton}
                        title={hasEvahIaDetalhado ? "Evah Ia" : "Conheça nossa IA"}
                        icon={EvahIaIcon}
                        onClick={() => this.clickOptions('evahIa')}
                        disabled={!sujeitoAtencaoId}
                        purpleColor
                        transition
                    />
                </Tooltip>}
            </div>
        )
    }


    render() {
        return <ButtonOptions buttons={this.renderButtons}/>
    }
}

const styles = () => ({
    buttonsContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    iconButton: {
        color: 'white',
    },
    customTooltip: {
        backgroundColor: 'rgba(150, 38, 172, 1) !important',
        color: 'white !important',
        fontSize: '16px !important',
        width: '140px',
        borderRadius: '16px 16px 0',
        padding: '8px 16px',
        transform: 'translateY(-32px) !important',
        animation: 'tooltipSlideUp 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards',
    },
    '@keyframes tooltipSlideUp': {
        '0%': {
            opacity: 0,
            transform: 'translateY(-10px) scale(0.9)',
        },
        '30%': {
            opacity: 0.6,
            transform: 'translateY(-28px) scale(1.05)',
        },
        '70%': {
            opacity: 0.9,
            transform: 'translateY(-35px) scale(1.1)',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(-32px) scale(1)',
        }
    }
})

export default withStyles(styles)(OpcoesProntuario);
